// extracted by mini-css-extract-plugin
module.exports = {"hasFloatingCta":"page-footer-module--hasFloatingCta--3Wp27","logo":"page-footer-module--logo--7WfQz"};